import React from "react";
import "./App.css";
import { Navbar } from "components";
import { Home } from "pages";

const App = () => {
  return (
    <>
      <div className="noise-overlay" />
      <Navbar />
      <Home />
    </>
  );
};

export default App;
